/**
 * Whether an element is rendered, by computed style. An element carrying `data-operator-description`
 * counts as visible whatever its style: `OperatorDescription` renders `display: none` on purpose so a
 * description can stand in for content that is not in the page.
 */
export const isElementVisible = (element: HTMLElement): boolean => {
  if (element.hasAttribute("data-operator-description")) {
    return true;
  }
  const style = window.getComputedStyle(element);
  return style.display !== "none" && style.visibility !== "hidden";
};
